import { DataSpec } from './data-spec.js'

export class DataSpecManager {
  static specRegistry: { [type: string]: DataSpec } = {}

  static getDataSpec(type: string): DataSpec {
    return DataSpecManager.specRegistry[type]
  }

  static registerDataSpec(type: string, dataSpec: DataSpec) {
    DataSpecManager.specRegistry[type] = dataSpec
  }

  static unregisterDataSpec(type: string) {
    delete DataSpecManager.specRegistry[type]
  }

  static getDataSpecs(): DataSpec[] {
    return Object.values(DataSpecManager.specRegistry)
  }
}
